import type { IconName } from '@freelancer/ui/icon';

export enum DefaultNavigationLink {
  SEARCH = '/search',
  DASHBOARD = '/dashboard',
  GIVE = '/give',
  POST_PROJECT = '/post-project',
  POST_AVAILABILITY = '/post-availability',
  MENU = '/navigation/menu',
  NAVIGATION_MANAGE = '/navigation/manage',
  GROUPS = '/groups/my-groups',
  GROUPS_ALL = '/groups',
  BROWSE = '/navigation/browse',
  SEARCH_AVAILABILITIES = '/search/availabilities',
  NAVIGATION_POST = '/navigation/post',
}

export enum MobileNavigationButtons {
  DASHBOARD,
  BROWSE,
  MANAGE,
  POST,
  GROUPS,
  MENU,
}

export enum FreightlancerNavigationLink {
  POST_LOAD = '/post-load',
  POST_AVAILABILITY = '/post-availability',
  BROWSE = '/navigation/browse',
  POST = '/navigation/post',
  BROWSE_LOADS = '/search/loads',
  FIND_TRUCKS = '/search/availabilities',
  MY_SHIPMENTS = '/manage', // Temporary link. Update to `/my-loads` once My Loads page is done
  GROUPS = '/groups',
}

export type NavigationLinks =
  | DefaultNavigationLink
  | FreightlancerNavigationLink;

export interface NavigationItem {
  /**
   * If the current url is in the `activeLinks` array or is equal to the singular `link` field,
   * the mobile navigation icon will be highlighted to indicate it is active.
   */
  readonly activeLinks?: readonly NavigationLinks[];
  readonly displayText?: string;
  readonly icon: IconName;
  readonly iconTitle: string;
  readonly link?: NavigationLinks;

  onClick?(): void;
}

export interface NavigationAlternate {
  readonly ctaLink: string;
  readonly ctaButtonType: CtaButtonType;
  readonly logo: {
    readonly default: string;
    readonly transparent: string;
    readonly mobileDefault?: string;
    readonly mobileTransparent?: string;
    readonly tabletDefault?: string;
    readonly tabletTransparent?: string;
  };
  readonly enableLinks?: boolean;
}

export enum CtaButtonType {
  DEMO,
  POST_PROJECT,
}
